import activity from './activity';
import address from './address';
import afterSale from './after-sale';
import commodity from './commodity';
import coupon from './coupon';
import customNotice from './custom-notice';
import login from './login';
import matomo from './matomo';
import modal from './modal';
import mp from './mp';
import order from './order';
import outsideComein from './outside-comein';
import placeOrder from './placeOrder';
import price from './price';
import resource from './resource';
import search from './search';
import sku from './sku';
import user from './user';
// #ifdef H5
import qiyu from './qiyu';
// #endif

export const businessUtils = {
  matomo,
  modal,
  order,
  mp,
  outsideComein,
  login,
  resource,
  sku,
  search,
  coupon,
  address,
  afterSale,
  commodity,
  activity,
  placeOrder,
  price,
  user,
  customNotice,
  // #ifdef H5
  qiyu,
  // #endif
};
